import React, { createContext, useEffect } from 'react';
import { Contract } from "web3-eth-contract"
import { MetaMaskInpageProvider } from '@metamask/providers';
import { Web3ContextType } from './context.types';
import Web3 from 'web3';
import { useDispatch } from 'react-redux';
import { GetVouchers } from '../pages/nfts/store/nfts.actions';
import { marketplaceAbi } from '../contracts/marketplace';


type Props = {
    children: React.ReactNode
}

declare global {
    interface Window {
        ethereum: MetaMaskInpageProvider;
    }
}

export const Web3Context = createContext<Web3ContextType | null>(null);

export const detectCurrentProvider = () => {
    let provider;
    if (window.ethereum) {
        provider = window.ethereum;
    } else {
        console.log('Non-ethereum browser detected');
    }
    return provider;
}

// receive react component
export const Web3ContextProvider = ({children}: Props) => {
    
    const dispatch = useDispatch();

    const [web3, setWeb3] = React.useState<Web3>();
    const [address, setAddress] = React.useState<string>('');
    const [connected, setConnected] = React.useState<boolean>(false);
    const [marketplaceContract, setMarketContract] = React.useState<Contract<typeof marketplaceAbi>>(null);

    const initWeb3 = async () => {
        try {
            const currentProvicer = detectCurrentProvider();
            if(currentProvicer) {
                if(currentProvicer !== window.ethereum) {
                    console.log('Non-ethereum browser detected');
                    return;
                }
                await currentProvicer.request({method: 'eth_requestAccounts'});
                const _web3 = new Web3(currentProvicer as any);

                const chainId = await _web3.eth.getChainId();
                if(process.env.REACT_APP_CHAIN_ID as any !== chainId) {
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: process.env.REACT_APP_CHAIN_ID }], // chainId must be in hexadecimal numbers
                    });
                }

                const _contract = new _web3.eth.Contract(marketplaceAbi as any, process.env.REACT_APP_MARKETPLACE_CONTRACT);
                setMarketContract(_contract);

                setWeb3(_web3);
                const userAccounts = await _web3.eth.getAccounts();
                const account = userAccounts[0];
                dispatch(GetVouchers(account));
                setAddress(account);
                setConnected(true);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if(window.ethereum) {
            window.ethereum.on('accountsChanged', (accounts) => {
                console.log('account is changed');
                updateAddress((accounts as string[])[0]);
            })
        }
    }, [])

    const updateAddress = (newAddress: string) => {
        setAddress(newAddress);
    }

    useEffect(() => {
        // initWeb3();
    }, [])

    return (
        <Web3Context.Provider
            value={{
                web3,
                address,
                connected,
                marketplaceContract
            }}
        >
            {children}
        </Web3Context.Provider>
    )
}